"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
// This file has been auto-generated. Do not modify directly!
const theme = {
  colors: {
    white: '#fff',
    black: '#000',
    'maple-50': '#FFF5F5',
    'maple-100': '#FDD6D7',
    'maple-200': '#FBB9BB',
    'maple-300': '#F58286',
    'maple-400': '#ED5153',
    'maple-500': '#DE2E37',
    'maple-600': '#CC1820',
    'maple-700': '#B30A11',
    'maple-800': '#950307',
    'maple-900': '#710003',
    'maple-1000': '#4D0001',
    'blue-50': '#F5F7FF',
    'blue-100': '#D6DFFD',
    'blue-200': '#B9C8FB',
    'blue-300': '#829FF5',
    'blue-400': '#537DEC',
    'blue-500': '#2E61DE',
    'blue-600': '#1844CC',
    'blue-700': '#0A2BB3',
    'blue-800': '#031795',
    'blue-900': '#000A71',
    'blue-1000': '#00034D',
    'green-50': '#F5FFF6',
    'green-100': '#D8FCDC',
    'green-200': '#BCFAC5',
    'green-300': '#88F398',
    'green-400': '#5BE873',
    'green-500': '#38DA57',
    'green-600': '#1FC641',
    'green-700': '#0EAD30',
    'green-800': '#059118',
    'green-900': '#006F07',
    'green-1000': '#014D00',
    'orange-50': '#FFFBF5',
    'orange-100': '#FFEDD4',
    'orange-200': '#FFDFB4',
    'orange-300': '#FCC37A',
    'orange-400': '#F5A647',
    'orange-500': '#EA891E',
    'orange-600': '#D5730C',
    'orange-700': '#BB5C02',
    'orange-800': '#9A4800',
    'orange-900': '#743300',
    'orange-1000': '#4D2000',
    'gray-50': '#F2F5F8',
    'gray-100': '#D7DCE1',
    'gray-200': '#BCC4CA',
    'gray-300': '#A3ABB3',
    'gray-400': '#8B939B',
    'gray-500': '#737B83',
    'gray-600': '#5C626A',
    'gray-700': '#464A51',
    'gray-800': '#2F3137',
    'gray-850': '#232429',
    'gray-900': '#18191D',
    'gray-950': '#111214',
    'gray-1000': '#020203',
    primary: '#0EAD30',
    secondary: '#2E61DE',
    danger: '#DE2E37',
    warning: '#EA891E',
    textBody: '#464A51',
    textHeading: '#020203',
    textDimmed: '#5C626A',
    dimmed: '#F2F5F8',
    disabled: '#D7DCE1',
    bodyBg: '#F2F5F8'
  },
  breakpoints: ['601px', '1024px'],
  fontFamily: {
    serif: 'serif',
    'sans-serif': 'Lato, Helvetica Neue, Helvetica, Arial, sans-serif',
    monospace: 'monospace'
  },
  space: [0, '0.375rem', '0.75rem', '1.125rem', '1.5rem', '1.875rem', '2.25rem', '2.625rem', '3rem', '3.375rem', '3.75rem'],
  lineHeights: [0, '0.375rem', '0.75rem', '1.125rem', '1.5rem', '1.875rem', '2.25rem', '2.625rem', '3rem', '3.375rem', '3.75rem'],
  fontSizes: {
    'text-xxl': '2.25rem',
    'text-xl': '1.5rem',
    'text-l': '1.125rem',
    text: '1rem',
    'text-s': '0.875rem',
    'text-xs': '0.75rem',
    'text-xxs': '0.5rem',
    xxlarge: '2.25rem',
    xlarge: '1.5rem',
    large: '1.125rem',
    '': '1rem',
    small: '0.875rem',
    xsmall: '0.75rem',
    xxsmall: '0.5rem'
  },
  fontWeights: {
    regular: '400',
    bold: '700'
  },
  letterSpacings: ['normal', '0.03125rem', '0.0625rem', '0.09375rem'],
  shadows: ['0 0.0625rem 0.125rem rgba(12, 13, 13, 0.15)', '0 0.125rem 0.25rem rgba(12, 13, 13, 0.15)', '0 0.1875rem 0.375rem rgba(12, 13, 13, 0.15)', '0 0.375rem 0.75rem rgba(12, 13, 13, 0.15)', '0 0.75rem 1.5rem rgba(12, 13, 13, 0.15)'],
  innerShadows: ['inset 0 0.0625rem 0.125rem rgba(56, 61, 61, 0.1)', 'inset 0 0 0.375rem rgba(12, 13, 13, 0.18)'],
  innerShadowsN: ['inset 0 -0.0625rem 0.1875rem rgba(12, 13, 13, 0.18)'],
  borderShadows: ['0 0 0 0.0625rem rgba(12, 13, 13, 0.15)'],
  radii: {
    'radius-1': '0.1875rem',
    'radius-2': '0.375rem',
    'radius-circle': '50%'
  },
  transition: {
    'transition-duration-fast': '100ms',
    'transition-duration-base': '200ms',
    'transition-duration-slow': '300ms'
  },
  alertVariants: {
    success: {
      background: '#F5FFF6',
      borderColor: '#0EAD30',
      '.fl-alert__icon svg': {
        fill: 'primary'
      }
    },
    info: {
      background: '#F5F7FF',
      borderColor: '#2E61DE',
      '.fl-alert__icon svg': {
        fill: 'secondary'
      }
    },
    danger: {
      background: '#FFF5F5',
      borderColor: '#DE2E37',
      '.fl-alert__icon svg': {
        fill: 'danger'
      }
    },
    warning: {
      background: '#FFFBF5',
      borderColor: '#EA891E',
      '.fl-alert__icon svg': {
        fill: 'warning'
      }
    }
  },
  alertInCardVariants: {
    success: {
      bg: 'green-50',
      borderColor: 'green-100',
      '.fl-alert__icon svg': {
        fill: 'primary'
      }
    },
    info: {
      bg: 'blue-50',
      borderColor: 'blue-100',
      '.fl-alert__icon svg': {
        fill: 'secondary'
      }
    },
    danger: {
      bg: 'maple-50',
      borderColor: 'maple-100',
      '.fl-alert__icon svg': {
        fill: 'danger'
      }
    },
    warning: {
      bg: 'orange-50',
      borderColor: 'orange-100',
      '.fl-alert__icon svg': {
        fill: 'warning'
      }
    }
  },
  badgeVariants: {
    default: {
      backgroundColor: '#D7DCE1',
      color: '#18191D'
    },
    success: {
      backgroundColor: '#0EAD30',
      color: '#fff'
    },
    warning: {
      backgroundColor: '#EA891E',
      color: '#18191D'
    },
    danger: {
      backgroundColor: '#DE2E37',
      color: '#fff'
    },
    info: {
      backgroundColor: '#2E61DE',
      color: '#fff'
    },
    important: {
      backgroundColor: '#2E61DE',
      color: '#fff'
    }
  },
  nextBadgeVariants: {
    danger: {
      bg: 'maple-200',
      borderColor: 'maple-300'
    },
    default: {
      bg: 'gray-100',
      borderColor: 'gray-200'
    },
    primary: {
      bg: 'blue-100',
      borderColor: 'blue-200'
    },
    success: {
      bg: 'green-200',
      borderColor: 'green-400'
    },
    warning: {
      bg: 'orange-200',
      borderColor: 'orange-300'
    }
  },
  buttonVariants: {
    fill: {
      primary: {
        backgroundImage: 'linear-gradient(180deg, #0EAD30, #059118)',
        backgroundColor: '',
        borderColor: '#006F07',
        color: '#fff',
        '&:hover': {
          color: '#fff',
          backgroundColor: '#059118',
          backgroundImage: 'linear-gradient(180deg, #059118, #059118)'
        },
        '&:active': {
          boxShadow: 'inset 0 2px 3px 0 rgba(24,25,29,0.3)'
        }
      },
      secondary: {
        backgroundImage: 'linear-gradient(180deg, #537DEC, #2E61DE)',
        backgroundColor: '',
        borderColor: '#1844CC',
        color: '#fff',
        '&:hover': {
          color: '#fff',
          backgroundColor: '#2E61DE',
          backgroundImage: 'linear-gradient(180deg, #2E61DE, #2E61DE)',
          borderColor: ''
        },
        '&:active': {
          boxShadow: 'inset 0 2px 3px 0 rgba(24,25,29,0.3)'
        }
      },
      danger: {
        backgroundImage: 'linear-gradient(180deg, #ED5153, #DE2E37)',
        backgroundColor: '',
        borderColor: '#CC1820',
        color: '#fff',
        '&:hover': {
          color: '#fff',
          backgroundColor: '#DE2E37',
          backgroundImage: 'linear-gradient(180deg, #DE2E37, #DE2E37)',
          borderColor: ''
        },
        '&:active': {
          boxShadow: 'inset 0 2px 3px 0 rgba(24,25,29,0.3)'
        }
      },
      neutral: {
        backgroundImage: 'linear-gradient(180deg, #fff, #F2F5F8)',
        backgroundColor: '',
        borderColor: '#BCC4CA',
        color: '#2F3137',
        '&:hover': {
          color: '#2F3137',
          backgroundColor: '#F2F5F8',
          backgroundImage: 'linear-gradient(180deg, #F2F5F8, #F2F5F8)',
          borderColor: ''
        },
        '&:active': {
          boxShadow: 'inset 0 1px 4px 0 rgba(24,25,29,0.3)'
        }
      }
    },
    outline: {
      primary: {
        color: '#059118',
        backgroundColor: '#fff',
        borderColor: '#059118',
        '&:hover': {
          backgroundColor: '#F5FFF6',
          color: '#059118',
          boxShadow: 'none',
          backgroundImage: 'none'
        },
        '&:active': {
          boxShadow: 'inset 0 1px 4px 0 rgba(24,25,29,0.3)'
        }
      },
      secondary: {
        color: '#2E61DE',
        backgroundColor: '#fff',
        borderColor: '#2E61DE',
        '&:hover': {
          backgroundColor: '#F5F7FF',
          color: '#2E61DE',
          boxShadow: 'none',
          backgroundImage: 'none'
        },
        '&:active': {
          boxShadow: 'inset 0 1px 4px 0 rgba(24,25,29,0.3)'
        }
      },
      danger: {
        color: '#DE2E37',
        backgroundColor: '#fff',
        borderColor: '#DE2E37',
        '&:hover': {
          backgroundColor: '#FFF5F5',
          color: '#DE2E37',
          boxShadow: 'none',
          backgroundImage: 'none'
        },
        '&:active': {
          boxShadow: 'inset 0 1px 4px 0 rgba(24,25,29,0.3)'
        }
      }
    }
  },
  buttonIconVariants: {
    fill: {
      primary: {
        fill: '#fff',
        color: '#0EAD30',
        '.cr-icon__details-2': {
          color: '#0EAD30',
          fill: '#0EAD30'
        }
      },
      secondary: {
        fill: '#fff',
        color: '#2E61DE',
        '.cr-icon__details-2': {
          color: '#2E61DE',
          fill: '#2E61DE'
        }
      },
      danger: {
        fill: '#fff',
        color: '#ED5153',
        '.cr-icon__details-2': {
          color: '#ED5153',
          fill: '#ED5153'
        }
      },
      neutral: {
        fill: '#2F3137',
        color: '#fff',
        '.cr-icon__details-2': {
          color: '#fff',
          fill: '#fff'
        }
      }
    },
    outline: {
      primary: {
        fill: '#059118',
        color: '#F5FFF6'
      },
      secondary: {
        fill: '#2E61DE',
        color: '#F5F7FF'
      },
      danger: {
        fill: '#DE2E37',
        color: '#FFF5F5'
      },
      neutral: {
        fill: '#2F3137',
        color: '#fff'
      }
    }
  },
  cardStyles: {
    background: '#fff',
    header: {
      border: '#D7DCE1'
    },
    footer: {
      border: '#D7DCE1'
    }
  },
  cardVariants: {
    neutral: {
      boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.06), 0 3px 6px 0 rgba(0, 0, 0, 0.03), 0 1px 2px 0 rgba(0, 0, 0, 0.1)'
    },
    top: {
      boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.06), 0 6px 12px 0 rgba(0, 0, 0, 0.03), 0 4px 8px 0 rgba(0, 0, 0, 0.08)'
    }
  },
  checkboxStyles: {
    background: 'linear-gradient(180deg, #fff, #F2F5F8)',
    borderColor: '#BCC4CA',
    color: '',
    focus: {
      boxShadow: ' 0 0 0 1px #fff, 0 0 0 3px #2E61DE'
    },
    indeterminate: {
      border: '#1844CC',
      background: '#1844CC'
    },
    checked: {
      background: 'linear-gradient(180deg, #537DEC, #2E61DE)',
      border: '#1844CC',
      color: '#fff'
    },
    label: {
      color: '#2F3137'
    },
    description: {
      color: '#2F3137'
    }
  },
  dividerStyles: {
    color: '#BCC4CA',
    cardColor: '#D7DCE1'
  },
  inputStyles: {
    background: '#fff',
    color: '#464A51',
    border: '#BCC4CA',
    boxShadow: 'inset 0 0.0625rem 0.125rem rgba(56, 61, 61, 0.1)',
    placeholder: {
      color: '#8B939B'
    },
    hover: {
      border: '#A3ABB3'
    },
    active: {
      border: '#2E61DE'
    },
    disabled: {
      color: '#8B939B',
      background: '#F2F5F8'
    },
    focus: {
      border: '#2E61DE'
    },
    helper: {
      background: '#2F3137'
    },
    warning: {
      color: '#EA891E'
    },
    error: {
      border: '#DE2E37',
      color: '#DE2E37'
    },
    valid: {
      color: '#0EAD30'
    },
    readonly: {
      color: '#464A51',
      background: '#F2F5F8'
    },
    label: {
      color: '#464A51'
    },
    autofilled: {
      background: '#fff',
      color: '#464A51'
    },
    autocomplete: {
      border: '#BCC4CA',
      controlDropdownIndicator: {
        color: '#F2F5F8'
      },
      controlHover: {
        border: '#A3ABB3'
      },
      indicator: {
        color: '#BCC4CA'
      },
      optionSelected: {
        background: '#F2F5F8',
        color: '#464A51'
      },
      multiValue: {
        color: '#464A51',
        background: '#fff',
        backgroundDisabled: '#fff',
        border: '#D7DCE1',
        borderDisabled: '#D7DCE1'
      },
      multiValueLabel: {
        color: '#464A51',
        colorDisabled: '#2F3137'
      },
      multiValueRemove: {
        color: '',
        colorDisabled: '#020203'
      }
    }
  },
  logoVariants: {
    flame: {
      default: {
        fill: '#ED5153'
      },
      'red-white': {
        fill: '#ED5153'
      },
      dive: {
        fill: '#18191D'
      },
      night: {
        fill: '#020203'
      },
      snow: {
        fill: '#fff'
      },
      maple: {
        fill: '#ED5153'
      }
    },
    word: {
      default: {
        fill: '#020203'
      },
      'red-white': {
        fill: '#fff'
      },
      dive: {
        fill: '#18191D'
      },
      night: {
        fill: '#020203'
      },
      snow: {
        fill: '#fff'
      },
      maple: {
        fill: '#ED5153'
      }
    }
  },
  radioStyles: {
    background: 'linear-gradient(180deg, #fff, #F2F5F8)',
    border: '#BCC4CA',
    color: '#fff',
    focus: {
      boxShadow: '#fff 0px 0px 0px 1px, #2E61DE 0px 0px 0px 3px'
    },
    checked: {
      background: 'linear-gradient(180deg, #537DEC, #2E61DE)',
      border: '#1844CC'
    },
    description: {
      color: '#737B83'
    },
    label: {
      color: '#020203'
    }
  },
  selectStyles: {
    backgroundColor: '',
    background: 'linear-gradient(180deg, #fff, #F2F5F8)',
    border: '#BCC4CA',
    color: '#2F3137',
    focusBorder: '#2E61DE',
    disabledColor: '',
    disabledBackground: ''
  },
  switchStyles: {
    on: {
      background: 'linear-gradient(180deg, #537DEC, #2E61DE)',
      border: '#1844CC',
      color: '#fff',
      focusBorder: '#2E61DE',
      errorBorder: '#DE2E37',
      checkedBorder: '#1844CC'
    },
    off: {
      background: 'linear-gradient(180deg, #fff, #F2F5F8)',
      border: '#D7DCE1',
      color: '#5C626A'
    },
    slider: {
      border: '#BCC4CA',
      background: '#fff',
      shadow: '0 0.125rem 0.25rem rgba(12, 13, 13, 0.15)'
    },
    icons: {
      checkmarkBackground: '#fff',
      crossBackground: '#5C626A'
    }
  },
  tagStyles: {
    main: {
      background: '#2E61DE',
      hoverBackground: '#537DEC',
      activeBackground: '#0A2BB3',
      focusBorder: '#2E61DE',
      color: '#fff',
      boxShadow: '0 0 0 0.0625rem #fff, 0 0 0 0.1875rem #2E61DE, inset 0 0 0.375rem rgba(12, 13, 13, 0.18)'
    },
    remove: {
      background: '#2E61DE',
      hoverBackground: '#537DEC',
      activeBackground: '#0A2BB3',
      icon: {
        background: 'rgba(2,2,3,0.4)',
        details: '#fff',
        hoverBackground: '',
        focusBackground: '',
        focusBoxShadow: '0 0 0 0.0625rem transparent, 0 0 0 0.125rem #fff',
        activeBackground: ''
      }
    }
  },
  tooltipStyles: {
    light: {
      background: '#F2F5F8',
      border: '#BCC4CA',
      color: '#464A51'
    },
    dark: {
      background: '#2F3137',
      border: '#18191D',
      color: '#fff'
    }
  },
  modalStyles: {
    overlay: {
      background: 'rgba(2,2,3,0.8)'
    },
    modal: {
      background: '#fff',
      color: '#2F3137'
    },
    header: {
      border: '#BCC4CA',
      color: '#020203'
    },
    footer: {
      background: '#F2F5F8',
      border: '#BCC4CA'
    }
  },
  progressStyles: {
    background: '#D7DCE1',
    progressBar: {
      background: '#D7DCE1 \nlinear-gradient(\n  45deg,\n  #2E61DE 0%,\n  #829FF5 25%,\n  #2E61DE 75%,\n  #829FF5 100%\n)\n',
      backgroundSize: '400% 400%'
    },
    progressBarStatic: {
      background: '#2E61DE'
    }
  },
  popoverStyles: {
    boxShadow: '0 0 0 0.0625rem rgba(12, 13, 13, 0.15), 0 0.1875rem 0.375rem rgba(12, 13, 13, 0.15)',
    arrowColor: '#BCC4CA',
    light: {
      background: '#fff'
    },
    dark: {
      background: '#F2F5F8'
    }
  },
  textStyles: {
    color: '#2F3137',
    link: {
      color: '#2E61DE'
    }
  },
  boneStyles: {
    background: '#D7DCE1'
  },
  groupStyles: {
    addon: {
      background: '#F2F5F8',
      borderColor: '#BCC4CA'
    }
  },
  wordmarkStyles: {
    border: '#ED5153',
    light: {
      color: '#fff'
    },
    dark: {
      color: '#020203'
    }
  },
  tableStyles: {
    progress: {
      background: 'linear-gradient(\n  45deg,\n  #2E61DE 0%,\n  #8fa5ff 25%,\n  #2E61DE 75%,\n  #8fa5ff 100%\n)',
      backgroundSize: '400% 400%',
      loadingBackground: '#D7DCE1'
    },
    tr: {
      hover: {
        background: '#fafbff'
      },
      borderColor: '#D7DCE1'
    },
    dropdown: {
      hover: {
        background: '#F2F5F8'
      }
    },
    sortable: {
      button: {
        background: 'rgba(46,97,222,0.1)'
      }
    }
  },
  sidebarStyles: {
    background: '#18191D',
    borderColor: '#464A51',
    iconDetails: '#18191D',
    sidebarLink: {
      focus: {
        background: '#2F3137'
      },
      active: {
        background: '#2E61DE'
      }
    },
    menulink: {
      normal: {
        color: '#2E61DE'
      },
      danger: {
        color: '#CC1820'
      }
    },
    shopButton: {
      background: '#2F3137',
      active: {
        background: '#464A51'
      },
      hover: {
        background: '#464A51'
      }
    },
    lockButton: {
      borderColor: '#737B83'
    }
  },
  npsStyles: {
    text: {
      dimmed: '#A3ABB3'
    }
  },
  toasterVariants: {
    success: {
      '.fl-toaster__container': {
        bg: 'green-50'
      },
      '.fl-toaster__countdown': {
        bg: 'primary'
      },
      '.fl-toaster__dismiss-btn svg': {
        fill: 'gray-400'
      },
      '.fl-toast__action-btn': {
        color: 'blue-500'
      }
    },
    error: {
      '.fl-toaster__container': {
        bg: 'maple-50'
      },
      '.fl-toaster__countdown': {
        bg: 'danger'
      },
      '.fl-toaster__dismiss-btn svg': {
        fill: 'gray-400'
      },
      '.fl-toast__action-btn': {
        color: 'blue-500'
      }
    }
  }
};
exports.theme = theme;